"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePhone = exports.getPhoneCodeFromCountry = exports.default = exports.DEFAULT_PHONE_ERROR = exports.DEFAULT_COUNTRY_CONFIG = exports.COUNTRIES_CONFIG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _x = _interopRequireDefault(require("country-flag-icons/react/3x2"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactBootstrap = require("react-bootstrap");
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _styles = _interopRequireDefault(require("./styles.scss"));
var _excluded = ["onChange", "onBlur", "handleKeyPress", "format", "value", "displayType", "placeholder", "autoFocus", "isNumericString", "customInput", "country", "hasError", "outdated", "internationalPhoneSupportEnabled"];
var countryFlagClass = _styles.default['country-flag'];
var DEFAULT_COUNTRY_CONFIG = {
  phoneCode: '+1',
  regex: /^\+1/,
  isoCode: 'US',
  formatter: function formatter(_phoneCode, phone) {
    return "(".concat(phone.slice(0, 3), ") ").concat(phone.slice(3, 6), "-").concat(phone.slice(6, 10));
  },
  format: '(###) ###-####'
};
exports.DEFAULT_COUNTRY_CONFIG = DEFAULT_COUNTRY_CONFIG;
var COUNTRIES_CONFIG = {
  '+91': {
    phoneCode: '+91',
    regex: /^\+91/,
    isoCode: 'IN',
    formatter: function formatter(phoneCode, phone) {
      return "".concat(phoneCode, " ").concat(phone.slice(0, 5), " ").concat(phone.slice(5, 10));
    },
    format: '##### #####'
  },
  '+1': DEFAULT_COUNTRY_CONFIG
};
exports.COUNTRIES_CONFIG = COUNTRIES_CONFIG;
var DEFAULT_PHONE_ERROR = 'Phone number is invalid format - should be 10 digits.';

/**
 * Get phone code from country, if country is US return null
 * @param {*} country
 * @returns
 */
exports.DEFAULT_PHONE_ERROR = DEFAULT_PHONE_ERROR;
var getPhoneCodeFromCountry = function getPhoneCodeFromCountry(country) {
  var phoneCode = _lodash.default.get(country, 'phoneCode');
  if (phoneCode && phoneCode !== DEFAULT_COUNTRY_CONFIG.phoneCode) {
    return phoneCode;
  }
  return null;
};
exports.getPhoneCodeFromCountry = getPhoneCodeFromCountry;
var validatePhone = function validatePhone(value, message, country) {
  var phoneCode = getPhoneCodeFromCountry(country);
  var phoneValue = value || '';
  if (value) {
    if (phoneCode && _lodash.default.startsWith(value, phoneCode)) {
      phoneValue = _lodash.default.replace(value, phoneCode, '');
    }
    phoneValue = phoneValue.replace(/[^0-9]/g, '');
  }
  return phoneValue.length < 10 ? message || DEFAULT_PHONE_ERROR : undefined;
};
exports.validatePhone = validatePhone;
var PhoneNumberInput = function PhoneNumberInput(props) {
  var onChange = props.onChange,
    onBlur = props.onBlur,
    handleKeyPress = props.handleKeyPress,
    format = props.format,
    value = props.value,
    displayType = props.displayType,
    placeholder = props.placeholder,
    autoFocus = props.autoFocus,
    isNumericString = props.isNumericString,
    customInput = props.customInput,
    country = props.country,
    hasError = props.hasError,
    outdated = props.outdated,
    internationalPhoneSupportEnabled = props.internationalPhoneSupportEnabled,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var Flag = null;
  var phoneMaskingFormat = format;
  if (country) {
    Flag = _x.default[_lodash.default.upperCase(country.isoCode)];
    if (COUNTRIES_CONFIG[country.phoneCode]) {
      phoneMaskingFormat = COUNTRIES_CONFIG[country.phoneCode].format;
    }
  }
  var convertInputValue = function convertInputValue(data) {
    var phoneCode = getPhoneCodeFromCountry(country);
    if (phoneCode && data && _lodash.default.startsWith(data, phoneCode)) {
      return _lodash.default.replace(data, phoneCode, '');
    }
    return data;
  };
  var onValueChange = function onValueChange(data) {
    var phoneCode = getPhoneCodeFromCountry(country);
    var submitValue = data && data.value;
    if (phoneCode && submitValue && !_lodash.default.startsWith(submitValue, phoneCode)) {
      submitValue = phoneCode + submitValue;
    }
    onChange(submitValue);
  };
  var handleBlur = function handleBlur() {
    if (onBlur) {
      onBlur();
    }
  };
  var onKeyPress = function onKeyPress(e) {
    if (e) {
      var event = {
        charCode: e.keyCode
      };
      handleKeyPress(event);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "\n      ".concat(hasError && "".concat(_styles.default['phone-error'], " "), "\n      ").concat(outdated && "".concat(_styles.default['phone-outdated'], " "), "\n      ").concat(Flag ? "".concat(countryFlagClass, " phone-with-country-wrapper") : 'phone-wrapper', "\n      ")
  }, Flag && internationalPhoneSupportEnabled && /*#__PURE__*/_react.default.createElement("div", {
    className: "flag-icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(Flag, {
    className: "flag-icon"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "code-info"
  }, " ", country.phoneCode, " ")), /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, (0, _extends2.default)({
    format: phoneMaskingFormat,
    value: convertInputValue(value),
    onValueChange: onValueChange,
    displayType: displayType,
    onKeyDown: onKeyPress,
    customInput: customInput,
    placeholder: placeholder,
    autoFocus: autoFocus,
    onBlur: handleBlur,
    isNumericString: isNumericString
  }, rest)));
};
PhoneNumberInput.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  onBlur: _propTypes.default.func,
  value: _propTypes.default.string,
  handleKeyPress: _propTypes.default.func,
  format: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  isNumericString: _propTypes.default.bool,
  displayType: _propTypes.default.string,
  customInput: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  country: _propTypes.default.shape({
    phoneCode: _propTypes.default.string,
    isoCode: _propTypes.default.string
  }),
  hasError: _propTypes.default.bool,
  outdated: _propTypes.default.bool,
  internationalPhoneSupportEnabled: _propTypes.default.bool
};
PhoneNumberInput.defaultProps = {
  format: DEFAULT_COUNTRY_CONFIG.format,
  placeholder: '',
  displayType: 'input',
  autoFocus: false,
  value: null,
  handleKeyPress: _lodash.default.noop,
  onBlur: _lodash.default.noop,
  isNumericString: true,
  customInput: _reactBootstrap.FormControl,
  country: {},
  hasError: false,
  outdated: false,
  internationalPhoneSupportEnabled: false
};
var _default = PhoneNumberInput;
exports.default = _default;